<div class="modal-content">
  <div class="modal-header">
    <div class="modal-title">
      <app-page-cardhead style="margin-top: -1.1rem" [PageName]="reportTitle" [PageHeadWidth]="600"></app-page-cardhead>
    </div>
    <button class="btn btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div modal-body class=" p-0">
    <section class="loans-section">

      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <table class="loans-table" #TABLE>
            <caption>
              {{ reportTitle }}
              <span *ngIf="startDate && endDate"> &mdash; {{ startDate }} to {{ endDate }}</span>
            </caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">ID Number</th>
                <th scope="col">First Name</th>
                <th scope="col">Middle Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Branch Name</th>
                <th scope="col">Branch Serial</th>
                <th scope="col">Query Date Time</th>
                <th scope="col">No Results Found</th>
                <th scope="col">Sanctions List Possible</th>
                <th scope="col">Sanctions List Confirmed</th>
                <th scope="col">Pep or Pip</th>
                <th scope="col">Reason Listed</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of lmsDataReportLst | paginate: config">
                <td>{{ row.idNumber }}</td>
                <td>{{ row.firstName }}</td>
                <td>{{ row.lastName }}</td>
                <td>{{ row.branchName }}</td>
                <td>{{ row.branchSerial }}</td>
                <td>{{ row.queryDateTime }}</td>
                <td>{{ row.noResultsFound }}</td>
                <td>{{ row.sanctionsListPossible }}</td>
                <td>{{ row.sanctionsListConfirmed }}</td>
                <td>{{ row.pipOrPep }}</td>
                <td>{{ row.reasonListed }}</td>
              </tr>
              <tr *ngIf="lmsDataReportLst.length === 0">
                <td colspan="12" class="text-center text-muted py-3">No data available.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator-row">
          <pagination-controls [id]="config.id || 'lexis-nexis-report-pager'"
            (pageChange)="config.currentPage = $event"></pagination-controls>
        </div>
      </div>

      <div class="action-bar">
        <button class="btn-action btn-export" type="button" (click)="exportToExcel()">
          <i class="fas fa-file-excel fa-fw"></i> Export to Excel
        </button>
        <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
      </div>

    </section>
  </div>
</div>
